"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrimaryNavTrayNavItem = PrimaryNavTrayNavItem;
exports.PrimaryNavTrayNavItemContainer = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _propTypes = _interopRequireDefault(require("prop-types"));
const PrimaryNavTrayNavItemContainer = exports.PrimaryNavTrayNavItemContainer = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "PrimaryNavTrayNavItemContainer",
  class: "pl-puahq95"
});
const NavItemIcon = "pl-neagq1h";

/**
 * Primary Nav Tray Nav Item component.
 *
 * @param {Object} props React props
 * @param {string} props.text Text string
 * @param {string} props.href Href string
 * @param {string} props.icon Icon string
 * @param {string} props._name Name for tracking
 * @returns {React.ReactElement} Primary Nav Tray Nav Item
 * @public
 */
function PrimaryNavTrayNavItem({
  icon,
  text,
  href,
  _name
}) {
  const icons = {
    'cart-v2': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "cart",
      className: NavItemIcon,
      fill: _intents.default.ux.box.foregroundColor
    }),
    'help': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "help",
      className: NavItemIcon,
      fill: _intents.default.ux.box.foregroundColor
    }),
    'user': /*#__PURE__*/_react.default.createElement(_icon.Icon, {
      name: "user",
      className: NavItemIcon,
      fill: _intents.default.ux.box.foregroundColor
    })
  };
  return /*#__PURE__*/_react.default.createElement(PrimaryNavTrayNavItemContainer, (0, _extends2.default)({
    href: href,
    "data-cy": "primary-nav-tray-nav-item"
  }, _patternLibraryUtils.tracking.create(_name, true, false)), icons[icon], " ", text);
}
PrimaryNavTrayNavItem.propTypes = {
  icon: _propTypes.default.string,
  text: _propTypes.default.string,
  href: _propTypes.default.string,
  _name: _propTypes.default.string
};